export enum DateFormat {
  default = 'MM/DD/YYYY',
  defaultFullTime = 'MM/DD/YYYY | hh-mm-a',
  long = 'MMMM DD, YYYY',
}

export type FormatDateResult<T> = T extends null | undefined
  ? undefined
  : string;
